import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addRouteCheckpoint,
  deleteCheckpoint,
  getRouteCheckpoints,
  getStageCheckpoints,
  replaceRouteCheckpoints,
  updateCheckpoint,
  uploadCheckpointImage,
} from "./checkpoints.service";

const routeCheckpointsKey = "jeep-rally-route-checkpoints";

export const useGetRouteCheckpoints = (routeId, params = {}, options = {}) => {
  return useQuery({
    queryKey: [routeCheckpointsKey, routeId, params],
    queryFn: () => getRouteCheckpoints(routeId, params),
    enabled: Boolean(routeId) && options.enabled !== false,
    ...options,
  });
};

export const useGetStageCheckpoints = (params = {}, options = {}) => {
  const stageId = params.stage_id || params.stageId;
  const categoryId = params.category_id || params.categoryId;
  return useQuery({
    queryKey: [routeCheckpointsKey, "stage", stageId, categoryId],
    queryFn: () => getStageCheckpoints(params),
    enabled:
      Boolean(stageId) &&
      Boolean(categoryId) &&
      options.enabled !== false,
    ...options,
  });
};

export const useAddRouteCheckpointMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId, payload }) =>
      addRouteCheckpoint(routeId, payload),
    onSuccess: (_data, variables) => {
      if (variables?.routeId) {
        queryClient.invalidateQueries({
          queryKey: [routeCheckpointsKey, variables.routeId],
        });
      }
    },
  });
};

export const useReplaceRouteCheckpointsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId, payload }) =>
      replaceRouteCheckpoints(routeId, payload),
    onSuccess: (_data, variables) => {
      if (variables?.routeId) {
        queryClient.invalidateQueries({
          queryKey: [routeCheckpointsKey, variables.routeId],
        });
      }
    },
  });
};

export const useUpdateCheckpointMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ checkpointId, payload }) =>
      updateCheckpoint(checkpointId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [routeCheckpointsKey] });
    },
  });
};

export const useUploadCheckpointImageMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ checkpointId, file }) =>
      uploadCheckpointImage(checkpointId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [routeCheckpointsKey] });
    },
  });
};

export const useDeleteCheckpointMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ checkpointId }) => deleteCheckpoint(checkpointId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [routeCheckpointsKey] });
    },
  });
};
